export class SearchEconomicalGroupModel {

    serviceContract: string;
    institution: string;
    size: string;
    pageNumber: string;
}
